import apiServices from './apiServices'

export default class extends apiServices {
  // Charge la liste des questions pour le calcul du Green Score du camping
  static load (campingId) {
    return this.get('/api/green/' + campingId, null)
  }

  // stocker les réponses aux questions d'un camping
  static updateAnswers (campingId, questions) {
    return this.post('/api/green/' + campingId + '/questions', questions)
  }

  // poster des textes pour VeryGreenActs
  static submitGreenActs (campingId, acts) {
    return this.post('/api/green/' + campingId + '/acts', acts)
  }
}
